"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.byDataHook = void 0;
const byDataHook = (dataHooks) => dataHooks
    .split(' ')
    .filter(Boolean)
    .map((hook) => `[data-hook~="${hook}"]`)
    .join('');
exports.byDataHook = byDataHook;
//# sourceMappingURL=byDataHook.js.map